import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import EmailUnsubscribeLanding from './email-unsubscribe-landing';
import EmailUnsubscribeOptIn from './email-unsubscribe-opt-in';
import EmailUnsubscribeOptOut from './email-unsubscribe-opt-out';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.route != this.props.route) {
            return true;
        }

        if (nextProps.list_status != this.props.list_status) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <member-email-unsubscribe>
                {this.renderFunction()}
            </member-email-unsubscribe>
        );
    }

    renderFunction() {
        if (this.props.route == 'opt-out') {
            return (<EmailUnsubscribeOptOut />);
        } else if (this.props.route == 'opt-in' || this.props.route == 'keep') {
            return (<EmailUnsubscribeOptIn />);
        }

        return (<EmailUnsubscribeLanding />);
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    list_status: state['email-unsub'] && state['email-unsub'].list_status,
});

export default connect(mapStateToProps)(Component);


